import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
} from '../styles';

import {
  ButtonContainer,
  ButtonShowImage,
  CentralizedQuestionLabel,
  Image,
  ImageBlank,
} from './styles';

const UI_ELEMENT_DISPLAY_TIME_MS = 1000;

const FiveSecondQuestionType = (props) => {
  const {
    label,
    displayTime,
    src,
    submitQuestions,
  } = props;
  const [showImage, setShowImage] = useState(false);

  const handleClick = () => {
    setShowImage(true);
    setTimeout(() => {
      setShowImage(false);
      submitQuestions();
    }, (displayTime * UI_ELEMENT_DISPLAY_TIME_MS));
  };

  // prevent users using right-click to download the image
  const handleRightClick = (e) => {
    e.preventDefault();
  };

  return (
    <Container>
      <CentralizedQuestionLabel>
        {label}
      </CentralizedQuestionLabel>

      {!showImage && (
        <ButtonContainer>
          <ButtonShowImage onClick={handleClick}>
            View Image for
            {' '}
            {displayTime}
            {' '}
            seconds
          </ButtonShowImage>
        </ButtonContainer>
      )}
      {showImage && (
        <Image
          src={src}
          onContextMenu={handleRightClick}
        />
      )}
      {!showImage && (
        <ImageBlank />
      )}
    </Container>
  );
};

FiveSecondQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  displayTime: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  submitQuestions: PropTypes.isRequired,
};

export default FiveSecondQuestionType;
